module.exports = __webpack_public_path__ + "media/images/symbol-defs-53c8ad78.svg";